/**
 * Công thức thanh toán định kỳ OD Travel — NGUỒN DUY NHẤT.
 * Dùng chung cho form khách hàng (DeviceModal) và Máy tính kỳ hạn (App).
 *
 * Lãi PHẲNG 8%/tháng (do OD Travel quy định) — hệ số = 1 + 0,08 × số tháng, không
 * hiển thị hệ số ra ngoài giao diện khách:
 *   1→1,08 · 2→1,16 · 3→1,24 · 4→1,32 · 5→1,40 · 6→1,48.
 * Kỳ hạn tối đa 6 tháng (dropdown giới hạn 1–6). months < 1: ×1 (không phụ phí);
 * >6 (hợp đồng cũ) vẫn nội suy tuyến tính cùng công thức.
 */
export function rateMultiplier(months) {
  const m = Number(months);
  return m >= 1 ? 1 + 0.08 * m : 1;
}

// Thanh toán/tháng = (tổng − trả trước) × hệ số / số tháng. '' nếu thiếu dữ liệu.
export function calcMonthly(o) {
  const total = Number(o.total_amount), down = Number(o.down_payment) || 0, months = Number(o.installment_months);
  if (!(total > 0) || !(months > 0) || total - down < 0) return '';
  const remaining = (total - down) * rateMultiplier(months);
  return String(Math.round(remaining / months));
}

// Tổng phải trả (gồm phụ phí) = trả trước + (tổng − trả trước) × hệ số. Gốc theo dõi "còn lại".
export function totalWithInterest(o) {
  const total = Number(o.total_amount) || 0, down = Number(o.down_payment) || 0, months = Number(o.installment_months);
  if (!(total > 0) || !(months > 0)) return 0;
  return down + (total - down) * rateMultiplier(months);
}

// Phí dịch vụ phải trả = (tổng − trả trước) × (hệ số − 1). 0 nếu thiếu dữ liệu.
export function interestAmount(o) {
  const total = Number(o.total_amount) || 0, down = Number(o.down_payment) || 0, months = Number(o.installment_months);
  if (!(total > 0) || !(months > 0)) return 0;
  return (total - down) * (rateMultiplier(months) - 1);
}
